import React, { forwardRef, useState } from "react";
import _ from "lodash";
import { replace } from "lodash";
import DatePicker from "react-datepicker";

import ButtonSecondary from "./ButtonSecondary";
import Calendar from "../icons/Calendar";

const parseDateRangeInputValue = (value) => {
  const [dateRangeInputValueStart, dateRangeInputValueEnd] = _(value)
    .chain()
    .split("-")
    .map((i) => replace(i, /\s+/g, ""))
    .value();

  if (!dateRangeInputValueEnd) {
    return dateRangeInputValueStart + " - " + "End date";
  }

  return value;
};

const DateRangeInput = forwardRef(({ value, onClick, ...props }, ref) => (
  <ButtonSecondary
    text={parseDateRangeInputValue(value)}
    onClick={onClick}
    ref={ref}
    icon={Calendar}
    className={"w-54"}
    {...props}
  />
));

DateRangeInput.displayName = "DateRangeInput";

const DateRangePicker = ({ dateFilter, maxDays }) => {
  const { startDate, endDate, setStartDate, setEndDate } = dateFilter;
  const [pickerStartDate, setPickerStartDate] = useState(startDate);
  const [pickerEndDate, setPickerEndDate] = useState(endDate);

  const onChange = (dates) => {
    const [start, end] = dates;

    // If maxDays is specified, validate the date range
    if (maxDays && start && end) {
      const daysDiff = Math.ceil((end - start) / (1000 * 60 * 60 * 24));

      if (daysDiff > maxDays) {
        // If the range is too large, adjust the end date
        const maxEndDate = new Date(start);
        maxEndDate.setDate(start.getDate() + maxDays - 1); // -1 because we want maxDays total days
        setPickerStartDate(start);
        setPickerEndDate(maxEndDate);
        return;
      }
    }

    setPickerStartDate(start);
    setPickerEndDate(end);
  };

  const onCalendarClose = () => {
    setStartDate(pickerStartDate);
    setEndDate(pickerEndDate);
  };

  // Calculate the maximum selectable date based on start date and maxDays
  const maxDate =
    maxDays && pickerStartDate
      ? new Date(
          pickerStartDate.getTime() + (maxDays - 1) * 24 * 60 * 60 * 1000
        )
      : null;

  return (
    <DatePicker
      selectsRange
      selected={pickerStartDate}
      startDate={pickerStartDate}
      endDate={pickerEndDate}
      onChange={onChange}
      onCalendarClose={onCalendarClose}
      customInput={<DateRangeInput />}
      maxDate={maxDate}
    />
  );
};

export default DateRangePicker;
